const baseUrlArr = [
    'https://api.zhaopinw.com/',
    'https://api.zhaopinw.com/',
    'https://apix.zhaopinw.com/',
    'https://apix.zhaopinw.com/',
    'https://apiy.zhaopinw.com/'
    // 'http://47.96.90.112:7856/'
]

/**
 * @author lihh
 * @description 平均获取请求的url
 */
const getRequestUrl = () => baseUrlArr[Math.floor(Math.random() * baseUrlArr.length)] || baseUrlArr[0]

exports.SERVICE_TYPE_HPC = 'hpc';
exports.SERVICE_TYPE_HPO = 'hpo';
exports.SERVICE_TYPE_HPM = 'hpm';
exports.BASE_URL = getRequestUrl();
exports.getRequestUrl = getRequestUrl


// WEBPACK FOOTER //
// ./src/utils/define.js